import { Parser } from "@json2csv/plainjs"
import { AxiosResponse } from "axios"
import fileDownload from "js-file-download"
import {
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from "react"
import { getCurrentDateFormatted } from "../utils/formats"
import { DOCUMENT_PREFIX } from "./constants"

interface DownloadFileProviderProps {
  children: ReactNode
}

interface DownloadFileContextType {
  handleDownloadXml: (fileName: string, data: BlobPart) => void
  handleDownloadPdf: (fileName: string, data: BlobPart) => void
  handleDownloadEdi: (fileName: string, data: BlobPart) => void
  handleDownloadExcel: (object: Record<string, string>[], name?: string) => void
  handleDirectDownloadExcel: (res: AxiosResponse, name?: string) => void
  handleDownloadFile: (data: string, fileName?: string) => void
}

// @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
const DownloadFileContext = createContext<DownloadFileContextType>()

const DownloadFileProvider = ({ children }: DownloadFileProviderProps) => {
  const anchor = useRef()

  useEffect(() => {
    const a = document.createElement("a")
    a.style.display = "none"
    document.body.appendChild(a)
    // @ts-expect-error TS(2322): Type 'HTMLAnchorElement' is not assignable to type...
    anchor.current = a
  }, [])

  const handleDownloadPdf = (fileName = "factura", data: BlobPart) => {
    fileDownload(new Blob([data]), `${fileName}.pdf`)
  }

  const handleDownloadXml = (fileName = "factura", data: BlobPart) => {
    fileDownload(new Blob([data], { type: "text/plain" }), `${fileName}.xml`)
  }

  const handleDownloadEdi = (fileName = "factura", data: BlobPart) => {
    // fileDownload(new Blob([data], { type: 'text/plain' }), `${fileName}.edi`);
    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", `${fileName}.edi`)
    document.body.appendChild(link)
    link.click()
  }

  const handleDownloadExcel = useCallback(
    // @ts-expect-error TS(7030): Not all code paths return a value.
    (object: Record<string, string>[], name = "") => {
      const headers = Object.keys(object[0]).map((key) => key)
      const opts = { headers, delimiter: ";" }
      const parser = new Parser(opts)

      try {
        const csv = parser.parse(object)
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        anchor.current.href = `data:text/csv;charset=utf-8,${`\uFEFF${encodeURIComponent(
          csv
        )}`}`
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        anchor.current.download = `${DOCUMENT_PREFIX}_${name}_(${getCurrentDateFormatted()}).csv`
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        anchor.current.click()
      } catch (err) {
        return null
      }
    },
    []
  )

  const handleDirectDownloadExcel = useCallback(
    (res: AxiosResponse, name = "") => {
      const path = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement("a")
      link.href = path
      link.setAttribute("download", name)
      document.body.appendChild(link)
      link.click()
    },
    []
  )

  const handleDownloadFile = useCallback((data: string, fileName?: string) => {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    anchor.current.href = data
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    anchor.current.download = fileName
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    anchor.current.click()
  }, [])

  const value = {
    handleDownloadXml,
    handleDownloadPdf,
    handleDownloadEdi,
    handleDownloadExcel,
    handleDirectDownloadExcel,
    handleDownloadFile,
  }

  return (
    <DownloadFileContext.Provider value={value}>
      {children}
    </DownloadFileContext.Provider>
  )
}

export const useDownloadFileContext = () => useContext(DownloadFileContext)

export default DownloadFileProvider

export const handleDirectDownloadExcel = (data: Blob, name = "") => {
  const path = window.URL.createObjectURL(data)
  const link = document.createElement("a")
  link.href = path
  link.setAttribute("download", name)
  document.body.appendChild(link)
  link.click()
}
